import * as React from 'react';

const CloseIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M8.75 8.75L21.25 21.25M21.25 8.75L8.75 21.25"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
    />
  </svg>
);

export default CloseIcon;
